import Checkmark32 from '@carbon/icons-react/es/checkmark/32';
import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { FormTheme } from 'api/form/types';

const ThemeTitle = styled.div<{ titleColor: string }>`
  height: var(--spacing-03);
  background: ${({ titleColor }) => titleColor};
`;
const ThemeHeader = styled.div<{ headerColor: string }>`
  height: var(--spacing-05);
  background: ${({ headerColor }) => headerColor};
`;
const ThemeBody = styled.div`
  height: var(--spacing-07);
  background: var(--white-100);
`;
const ThemeIconWrapper = styled.div<{
  isSelected: boolean;
}>`
  position: relative;
  width: 100px;
  margin: 0 var(--spacing-03) var(--spacing-03) 0;
  cursor: pointer;
  border: 2px solid transparent;
  &:hover {
    border-color: var(--blue-60);
  }
  ${ifProp(
    'isSelected',
    css`
      border-color: var(--blue-60);
    `,
  )};
`;
const ThemeDetails = styled.div<{
  backgroundColor: string;
  isSelected: boolean;
}>`
  padding: var(--spacing-06);
  background: ${({ backgroundColor }) => backgroundColor};
  ${ifProp(
    'isSelected',
    css`
      filter: brightness(80%);
    `,
  )};
`;
const ThemeTickIcon = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 5;
`;
const TickIconWrapper = styled.div`
  width: 18px;
  height: 18px;
  background: var(--blue-60);
  border-radius: 50%;
  display: flex;
  align-items: center;
  svg {
    fill: var(--white-100);
    width: 14px;
    height: 14px;
    margin: 0 auto;
  }
`;

export const TickIcon = () => {
  return (
    <TickIconWrapper>
      <Checkmark32 />
    </TickIconWrapper>
  );
};

export const ThemeIconRenderer = ({
  themeColor,
  isSelected,
  setThemeChange,
}: {
  themeColor: FormTheme;
  isSelected: boolean;
  setThemeChange: (updatedFormTheme: FormTheme) => void;
}): JSX.Element => {
  return (
    <ThemeIconWrapper
      isSelected={isSelected}
      onClick={() => setThemeChange(themeColor)}
    >
      {isSelected && (
        <ThemeTickIcon>
          <TickIcon />
        </ThemeTickIcon>
      )}
      <ThemeDetails
        backgroundColor={themeColor.backgroundColor}
        isSelected={isSelected}
      >
        <ThemeTitle titleColor={themeColor.titleBarColor} />
        <ThemeHeader headerColor={themeColor.headerColor} />
        <ThemeBody />
      </ThemeDetails>
    </ThemeIconWrapper>
  );
};
